import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from './linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { driverVersions } from 'app/registries/consts/tabular-consts';
import { LinkedServiceUtils } from './linked-service.utils';

@Metamodel.model({
    name: adfModelTypeMap.cassandra.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Cassandra_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Cassandra_DisplayText)
    ]
})
export class CassandraLinkedService extends LinkedService {
    public static readonly MODEL: IModel;
    @Metamodel.attribute({
        display: stringResources.VersionLabel
    })
    public version?: string = driverVersions.v2;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host
    })
    public host?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port
    })
    public port?: number;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public password?: string | AzureKeyVault; // TODO: need a secure type to make sure this won't be exposed to customer.

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public convertV1toV2(context: { inlineDataset?: boolean }): CassandraLinkedService {
        return LinkedServiceUtils.commonV1ToV2(context, this) as CassandraLinkedService;
    }
}
